export const pageTitles = {
  '/': {
    title: 'Dashboard',
    showBackButton: false
  },
  '/employees': {
    title: 'Employees',
    showBackButton: true
  },
  '/attendance': {
    title: 'Attendance',
    showBackButton: true
  },
  '/monthly-summary': {
    title: 'Monthly Attendance',
    showBackButton: true
  },
  '/leaves': {
    title: 'Apply Leave',
    showBackButton: true
  },
  '/leaves/quota': {
    title: 'Leave Quota',
    showBackButton: true
  },
  '/leaves/all': {
    title: 'All Leaves',
    showBackButton: true
  },
  '/leaves/setup': {
    title: 'Leave Setup',
    showBackButton: true
  },
  '/leaves/usage': {
    title: 'Leave Usage',
    showBackButton: true
  },
  '/holidays': {
    title: 'Holidays',
    showBackButton: true
  },
  '/payroll': {
    title: 'Payroll',
    showBackButton: true
  },
  '/payroll-summary': {
    title: 'Payroll Summary',
    showBackButton: true
  },
  '/settings': {
    title: 'Settings',
    showBackButton: true
  },
  '/login': {
    title: 'Login',
    showBackButton: false
  },
  '/unauthorized': {
    title: 'Unauthorized',
    showBackButton: true
  },
  '/not-found': {
    title: 'Page Not Found',
    showBackButton: true
  },
  '/app/appraisals/:id': {
    title: 'Appraisal',
    showBackButton: true
  },
  '/app/appraisals/edit/:id': {
    title: 'Edit Appraisal',
    showBackButton: true
  },
  '/app/employee-appraisals': {
    title: 'Employee Appraisals',
    showBackButton: true
  },
};
